import { createSlice } from "@reduxjs/toolkit";

const threeSlice = createSlice({
  name: "Narration",
  initialState: {
    lang: 0,
    langs: ["en", "ar", "es"],
    index1: 0,
  },
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload;
    },
    setIndex1: (state, action) => {
      state.index1 = action.payload;
    },
  },
});

export const { setLang, setIndex1 } = threeSlice.actions;

export default threeSlice.reducer;
